import { render, staticRenderFns } from "./NoticeFormView.vue?vue&type=template&id=74c00cf8"
import script from "./NoticeFormView.vue?vue&type=script&setup=true&lang=ts"
export * from "./NoticeFormView.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports